import { Box, chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Container = ({ children, className }: Props) => {
  return (
    <Box
      className={ className }
      minWidth={{ base: '100vw', lg: 'fit-content' }}
      m="0 auto"

      /**
       * Do not set page background here.
       * The page background should come from `<body>` (`bg.body`) so the whole app
       * uses the theme "body" background consistently.
       */
    >
      { children }
    </Box>
  );
};

export default React.memo(chakra(Container));
